import { render, staticRenderFns } from "./CreateNewPwd.vue?vue&type=template&id=125ba77c&scoped=true&"
import script from "./CreateNewPwd.vue?vue&type=script&lang=js&"
export * from "./CreateNewPwd.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewPwd.vue?vue&type=style&index=0&id=125ba77c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ba77c",
  null
  
)

export default component.exports